module.exports = __webpack_public_path__ + "2077386f38db980c6ae984d318a588a3.svg";